import { Content } from '../../types';

export const hoChiMinhCityContent: Content = {
  title: "הו צ'י מין סיטי - הלב הפועם של וייטנאם",
  imageUrl: '/images/vietnam/ho-chi-minh-city/ho-chi-minh-city-wide.jpeg',
  introduction: `הו צ'י מין סיטי, לשעבר סייגון, הינה העיר הגדולה ביותר בוייטנאם והמרכז הכלכלי והתרבותי של המדינה. בין השנים 1954 ועד 1976 שימשה כבירת דרום וייטנאם, עד אשר נכבשה על ידי צפון וייטנאם במהלך מלחמת וייטנאם. לאחר האיחוד הלאומי, שונה שמה כהוקרה להו צ'י מין, מנהיג המהפכה הקומוניסטית ומייסד צפון וייטנאם. למרות השינוי הרשמי, רבים מהתושבים והמטיילים עדיין מכנים אותה "סייגון".

העיר ממוקמת בדרום-מזרח וייטנאם ונחשבת למוקד התחבורה המרכזי של המדינה. היא מאכלסת כ-12 מיליון תושבים ומשמשת כמרכז כלכלי עולמי, עם גורדי שחקים מרשימים לצד מבנים קולוניאליים צרפתיים. שדה התעופה הבינלאומי שלה, טאן סון נהאט (Tan Son Nhat), הוא העמוס ביותר בוייטנאם ואחד המרכזיים בדרום-מזרח אסיה.

הרחובות בעיר סואנים בכל שעות היום והלילה וריבוי האופנועים הפך לאחד ממאפייניה הבולטים. חציית הכביש בהו צ'י מין סיטי הינה חוויה ייחודית הדורשת ערנות יתרה וסבלנות, אך הינה חלק בלתי נפרד מהחוויה המקומית.`,
  sections: [
    {
      title: 'אטרקציות מרכזיות',
      content: `העיר מציעה מגוון רחב של אתרי תיירות היסטוריים, תרבותיים וקולינריים. רבים מהאתרים המרכזיים ממוקמים ברובע 1 (District 1), מה שהופך אותו לאזור המומלץ ביותר לשהייה בעיר.`,
      type: 'text',
    },
    {
      title: 'אתרים היסטוריים ותרבותיים',
      content: [
        'ארמון האיחוד (Independence Palace) - שימש כארמון הנשיאות של דרום וייטנאם ונותר עדות למאורעות נפילת סייגון בשנת 1975.',
        'בניין העירייה של סייגון (Ho Chi Minh City Hall) - מבנה קולוניאלי מרשים מהמאה ה-19.',
        'בית הדואר המרכזי של סייגון (Central Post Office) - מבנה מרהיב בעיצובו, שתוכנן על ידי האדריכל הצרפתי גוסטב אייפל.',
        'קתדרלת נוטרדאם של סייגון (Notre-Dame Cathedral Basilica of Saigon) - כנסייה קתולית מרשימה שנבנתה בתקופה הקולוניאלית הצרפתית.',
        'מוזיאון שרידי המלחמה (War Remnants Museum) - מציג תיעוד מצמרר של מלחמת וייטנאם.',
        "מוזיאון הו צ'י מין (Ho Chi Minh Museum) - מוקדש למורשתו של המנהיג המהפכני.",
      ],
      type: 'list',
    },
    {
      title: 'שווקים, בילויים ונוף אורבני',
      content: [
        'שוק בן תאן (Ben Thanh Market) - אחד השווקים המפורסמים בעיר, מציע מזכרות, בגדים, תבלינים ואוכל רחוב אותנטי.',
        'רחוב בוי ויין (Bui Vien Walking Street) - אזור בילוי תוסס עם ברים, מסעדות ומועדונים הפועלים עד שעות הלילה המאוחרות.',
        'תצפית ממגדל ביטקסקו (Bitexco Financial Tower) - מספק נוף פנורמי עוצר נשימה של העיר, מומלץ במיוחד בשקיעה.',
        'שייט על נהר סייגון - חוויה קסומה הכוללת שיט לילי על הנהר, לעיתים מלווה בארוחות ערב יוקרתיות.',
        'פארק טאו דאן (Tao Dan Park) - ריאה ירוקה בלב העיר, מציעה מקום שקט למנוחה.',
      ],
      type: 'list',
    },
    {
      title: 'טיולים בסביבת העיר',
      content: [
        "הו צ'י מין סיטי מהווה גם בסיס יציאה נוח לטיולי יום מחוץ לעיר:",
        "תעלות קו צ'י (Cu Chi Tunnels) - רשת מחילות ששימשה את לוחמי הווייטקונג במהלך מלחמת וייטנאם. המבקרים יכולים לזחול בחלק מהמנהרות ולהבין את שיטות הלחימה ואורח חייהם של הלוחמים.",
        'דלתת המקונג (Mekong Delta) - חוויה ייחודית של שיט בין כפרים צפים, שווקים על המים ומטעי קוקוס.',
      ],
      type: 'list',
    },
    {
      title: 'המלצות לינה',
      content: [
        'רובע 1 (District 1) הינו המומלץ ביותר ללינה בזכות קרבתו לאטרקציות המרכזיות, למסעדות ולחיי הלילה התוססים. מלונות מומלצים:',
        'The Reverie Saigon - מלון יוקרה עם עיצוב אירופאי מפואר.',
        'Hotel Des Arts Saigon - מלון בוטיק אלגנטי עם אווירה צרפתית.',
        'Silverland Yen Hotel - מלון במחיר סביר עם מיקום מצוין וספא מפנק.',
        'Vy Khanh Guesthouse - אופציה תקציבית פופולרית עם שירות משפחתי חם.',
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, הו צ'י מין סיטי הינה עיר דינמית, מסקרנת ותוססת המשלבת היסטוריה עשירה עם מודרניות מרשימה. בין אם הינכם חובבי היסטוריה, אוכל רחוב, חיי לילה או תרבות מקומית - עיר זו מציעה חוויות בלתי נשכחות לכל סוגי המטיילים.`,
      type: 'text',
    },
  ],
};
